import script from "./PlacementAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./PlacementAudit.vue?vue&type=script&setup=true&lang=js"

import "./PlacementAudit.vue?vue&type=style&index=0&id=41bfc930&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41bfc930"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QTable,QSeparator});
